import { Outlet, Route, Routes, useLocation } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { FinanceiroAtendimentosListWrapper } from './atendimentos-nao-faturados/FinanceiroAtendimentosList'
import { FaturaListWrapper } from './faturas-list/FaturaList'
import { FaturaAtendimentosListWrapper } from './faturas-atendimentos-list/FaturaAtendimentosList'
import { FaturaProfissionalListWrapper } from './faturas-profissional-list/FaturaProfissionalList'
import { FaturaProfissionalAtendimentosListWrapper } from './faturas-profissional-atendimentos-list/FaturaProfissionalAtendimentosList'
import { NotaListWrapper } from './notas-list/NotaList'
import { NotaAtendimentosListWrapper } from './notas-atendimentos-list/NotaAtendimentosList'
import { FaturaResponsavelListWrapper } from './faturas-responsavel-list/FaturaResponsavelList'
import { useT } from '_metronic/i18n/Metronici18n'

const FinanceiroPage = () => {
  const { t } = useT()
  const location = useLocation()
  const pathParts = location.pathname.split('/')
  const idEmpresa = pathParts[5]
  const isResponsavel = !!idEmpresa
  const isProfissional = location.pathname.includes('/profissional')
  const isNotas = location.pathname.includes('/notas')
  const isFaturas = location.pathname.includes('/faturas')

  let title = ''
  let path = ''

  if (isNotas) {
    title = t('nota.plural')
    path = isProfissional ? '/financeiro/notas/profissional' : '/financeiro/notas'
  } else if (isFaturas) {
    title = isProfissional ? t('menu.minhas_faturas') : t('fatura.plural')
    path = isProfissional
      ? '/financeiro/faturas/profissional'
      : isResponsavel
      ? '/financeiro/faturas/responsavel'
      : '/financeiro/faturas'
  }

  const breadCrumbs: Array<PageLink> = [
    {
      title,
      path,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='atendimentos'
          element={
            <>
              <PageTitle description={t('pagina.atendimentosNaoFaturados.descricao')}>
                {t('title.atendimentos_nao_faturados')}
              </PageTitle>
              <FinanceiroAtendimentosListWrapper />
            </>
          }
        />
        <Route
          path='faturas'
          element={
            <>
              <PageTitle description={t('pagina.faturas.descricao')}>
                {t('fatura.plural')}
              </PageTitle>
              <FaturaListWrapper />
            </>
          }
        />
        <Route
          path='faturas/responsavel'
          element={
            <>
              <PageTitle description={t('pagina.faturasResponsavel.descricao')}>
                {t('fatura.plural')}
              </PageTitle>
              <FaturaResponsavelListWrapper />
            </>
          }
        />
        <Route
          path='faturas/profissional'
          element={
            <>
              <PageTitle description={t('pagina.minhasFaturas.descricao')}>
                {t('menu.minhas_faturas')}
              </PageTitle>
              <FaturaProfissionalListWrapper />
            </>
          }
        />
        <Route
          path='faturas/profissional/atendimentos/:idFatura'
          element={
            <>
              <PageTitle breadcrumbs={breadCrumbs}>{t('title.atendimentos_fatura')}</PageTitle>
              <FaturaProfissionalAtendimentosListWrapper />
            </>
          }
        />
        <Route
          path='faturas/atendimentos/:idFatura'
          element={
            <>
              <PageTitle breadcrumbs={breadCrumbs}>{t('title.atendimentos_fatura')}</PageTitle>
              <FaturaAtendimentosListWrapper />
            </>
          }
        />
        <Route
          path='faturas/atendimentos/:idFatura/:idEmpresa'
          element={
            <>
              <PageTitle breadcrumbs={breadCrumbs}>{t('title.atendimentos_fatura')}</PageTitle>
              <FaturaAtendimentosListWrapper />
            </>
          }
        />
        <Route
          path='notas'
          element={
            <>
              <PageTitle description={t('pagina.notas.descricao')}>{t('nota.plural')}</PageTitle>
              <NotaListWrapper />
            </>
          }
        />
        <Route
          path='notas/profissional'
          element={
            <>
              <PageTitle description={t('pagina.notasProfissional.descricao')}>
                {t('nota.plural')}
              </PageTitle>
              <NotaListWrapper />
            </>
          }
        />
        <Route
          path='notas/profissional/:idNota'
          element={
            <>
              <PageTitle description={t('pagina.notasProfissional.descricao')}>
                {t('nota.plural')}
              </PageTitle>
              <NotaListWrapper />
            </>
          }
        />
        <Route
          path='notas/profissional/atendimentos/:idNota'
          element={
            <>
              <PageTitle breadcrumbs={breadCrumbs}>{t('title.atendimentos_nota')}</PageTitle>
              <NotaAtendimentosListWrapper />
            </>
          }
        />
        <Route
          path='notas/atendimentos/:idNota'
          element={
            <>
              <PageTitle breadcrumbs={breadCrumbs}>{t('title.atendimentos_nota')}</PageTitle>
              <NotaAtendimentosListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default FinanceiroPage
